import {useDarkMode} from "../../contexts/darkModeContext";
import React, {useEffect, useState} from "react";
import {
    BeakerIcon, CalculatorIcon,
    ClipboardDocumentListIcon,
    XCircleIcon
} from "@heroicons/react/24/outline";
import {
    Button,
    Dialog,
    DialogBackdrop,
    DialogPanel, Input, Select,
    TransitionChild
} from "@headlessui/react";
import {db} from "../../firebase/firebase";
import {useAuth} from "../../contexts/authContext";
import {PlusIcon, XMarkIcon} from "@heroicons/react/16/solid";
import {Link, useNavigate} from "react-router-dom";
import imageICON from '../../GROLINKZ_ICON.png';

import {
    Bars3Icon,
    BellIcon,
    CalendarIcon,
    ChartPieIcon,
    Cog6ToothIcon,
    DocumentDuplicateIcon,
    FolderIcon,
    HomeIcon,
    UsersIcon,
} from '@heroicons/react/24/outline'
import logo from "../../GROLINKZ_ICON.png";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import {useNotification} from "../Notification/NotificationProvider";
import { ReactComponent as SPRAYER } from '../../customIcons/Sprayer_V3.svg';
import { ReactComponent as TOTE } from '../../customIcons/Tote.svg';
import { ReactComponent as LOGO } from '../../customIcons/GROLINKZ_LOGO.svg';
import { ReactComponent as JUG } from '../../customIcons/Jug.svg';


const SprayBuilder = () => {

    const { darkMode } = useDarkMode();
    const { currentUser } = useAuth();
    const { triggerNotification } = useNotification();
    const navigate = useNavigate();


    const [sprays, setSprays] = useState([]);
    const currentDate = new Date().toLocaleDateString('en-US').split('/').join('-');


    const [formData, setFormData] = useState({
        name: '',
        area: 0,
        areaUnit: '',
        date: '',
        purpose: '',
        rate: 0,
        tankNum: 0,
        tankVol: 0,
        target: '',
        ingredients: [],
        updated: false,
    });
    const [editingSprayId, setEditingSprayId] = useState(null);
    const [chems, setChems] = useState([]); // New state for chemicals
    const [filteredChems, setFilteredChems] = useState([]);



    useEffect(() => {
        const fetchChems = async () => {
            if (currentUser) {
                try {
                    const storedChemsData = localStorage.getItem(`chemsData_${currentUser.uid}`);
                    if (storedChemsData) {
                        const chemsData = JSON.parse(storedChemsData);
                        setChems(chemsData);
                        setFilteredChems(chemsData);
                        setCHEMS_LIST_ID("chems");
                        setINGREDIENTS_LIST_ID("ingredients");
                    } else {
                        const chemsRef = db.collection('Users').doc(currentUser.uid).collection('chems');
                        const snapshot = await chemsRef.get();
                        const chemsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                        setChems(chemsData);
                        setFilteredChems(chemsData);
                        setCHEMS_LIST_ID("chems");
                        setINGREDIENTS_LIST_ID("ingredients");
                        localStorage.setItem(`chemsData_${currentUser.uid}`, JSON.stringify(chemsData));
                    }
                } catch (error) {
                    console.error('Error fetching chemicals:', error);
                }
            }
        };

        fetchChems(); // Fetch chemicals when component mounts
    }, [currentUser]);




    const [CHEMS_LIST_ID, setCHEMS_LIST_ID] = useState("");
    const [INGREDIENTS_LIST_ID, setINGREDIENTS_LIST_ID] = useState("");

    const handleDragEnd = (result) => {
        const { source, destination} = result;
        if (!destination) return;

        if (
            (source.droppableId === CHEMS_LIST_ID && !chems) ||
            (source.droppableId !== CHEMS_LIST_ID && !formData.ingredients)
        ) {
            console.warn("Source list is undefined on drag start");
            return;
        }

        if (destination.droppableId === source.droppableId) {
            // Reorder within the same list
            if (source.droppableId === CHEMS_LIST_ID) {
                const updated = [...filteredChems];
                const [moved] = updated.splice(source.index, 1);
                updated.splice(destination.index, 0, moved);
                // setChems(updated);
                setFilteredChems(updated)
            } else {
                const updated = [...formData.ingredients];
                const [moved] = updated.splice(source.index, 1);
                updated.splice(destination.index, 0, moved);
                setFormData({ ...formData, ingredients: updated });
            }
        } else {
            // Move between lists
            const fromChems = source.droppableId === CHEMS_LIST_ID;
            const toChems = destination.droppableId === CHEMS_LIST_ID;

            const sourceList = fromChems ? [...filteredChems] : [...formData.ingredients];
            const destList = toChems ? [...filteredChems] : [...formData.ingredients];
            const [moved] = sourceList.splice(source.index, 1);
            destList.splice(destination.index, 0, moved);

            if (fromChems) {
                // setChems(sourceList);
                setFilteredChems(sourceList);
                setFormData({ ...formData, ingredients: destList });
            } else {
                setFormData({ ...formData, ingredients: sourceList });
                setChems(destList);
            }
        }
    };



    // const fillFormWithSprayData = (spray) => {
    //     // setIsCollapsed(true);
    //     setFormData({
    //         name: spray.name,
    //         area: spray.area,
    //         areaUnit: spray.areaUnit,
    //         date: spray.date,
    //         purpose: spray.purpose,
    //         rate: spray.rate,
    //         tankNum: spray.tankNum,
    //         tankVol: spray.tankVol,
    //         target: spray.target,
    //         ingredients: spray.ingredients
    //     });
    //     setEditingSprayId(spray.id);
    //     // if (isCollapsed === true){
    //     //     toggleCollapse();
    //     // }
    // };

    const clearForm = () => {
        setFormData({
            name: '',
            area: 0,
            areaUnit: '',
            date: '',
            purpose: '',
            rate: 0,
            tankNum: 0,
            tankVol: 0,
            target: '',
            ingredients: [],
            updated: false,
        });
        setEditingSprayId(null);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'date') {
            // If the changed field is 'date', directly set the value
            setFormData((prevData) => ({
                ...prevData,
                date: value,
            }));
        } else {
            // For other fields, update as usual
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };

    // Handle ingredient changes
    const handleIngredientChange = (index, field, event) => {
        const newIngredients = [...formData.ingredients];
        newIngredients[index][field] = field === 'rate' ? parseFloat(event.target.value) || 0 : event.target.value;
        setFormData({ ...formData, ingredients: newIngredients });
    };

    // Handle area change
    // const handleAreaChange = (event) => {
    //     setFormData({ ...formData, area: parseFloat(event.target.value) || 1 });
    // };
    //
    // // Remove an ingredient
    // const handleRemoveIngredients = (index) => {
    //     const newIngredients = [...formData.ingredients];
    //     newIngredients.splice(index, 1);
    //     setFormData({ ...formData, ingredients: newIngredients });
    // };
    //
    // // Add a new ingredient
    // const handleAddIngredient = () => {
    //     setFormData({
    //         ...formData,
    //         ingredients: [...formData.ingredients, { name: '', rate: 0 }]
    //     });
    // };

    // Generate pie chart data based on the entered values
    const pieData = {
        labels: formData.ingredients.map((ingredient, index) => ingredient.name || `Ingredient ${index + 1}`),
        datasets: [
            {
                data: formData.ingredients.map(ingredient => ingredient.rate * formData.area),
                backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40']
            }
        ]
    };

    const [sidebarOpen, setSidebarOpen] = useState(false)

    const navigation = [
        { name: 'Dashboard', href: '#', icon: HomeIcon, current: true },
        { name: 'Team', href: '#', icon: UsersIcon, current: false },
        { name: 'Projects', href: '#', icon: FolderIcon, current: false },
        { name: 'Calendar', href: '#', icon: CalendarIcon, current: false },
        { name: 'Documents', href: '#', icon: DocumentDuplicateIcon, current: false },
        { name: 'Reports', href: '#', icon: ChartPieIcon, current: false },
    ]
    const teams = [
        { id: 1, name: 'Heroicons', href: '#', initial: 'H', current: false },
        { id: 2, name: 'Tailwind Labs', href: '#', initial: 'T', current: false },
        { id: 3, name: 'Workcation', href: '#', initial: 'W', current: false },
    ]

    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }



    const handleSubmit = async (e) => {
        e.preventDefault();
        const collectionRef = db.collection('Users').doc(currentUser.uid).collection('sprays');

        // If date field is empty, set it to the current date
        const currentDate = new Date().toLocaleDateString('en-US').split('/').join('-');
        const formDataWithDate = {
            ...formData,
            date: formData.date || currentDate
        };

        // Map formDataWithDate.ingredients to include necessary fields
        const ingredientsData = await Promise.all(formDataWithDate.ingredients.map(async ingredient => {
            return {
                name: ingredient.name,
                weight: ingredient.weight,
                rate: ingredient.rate,
                unit: ingredient.unit,
                price: ingredient.unitprice,
                nutrients: ingredient.nutrients,
                containerVol: ingredient.volume,
                chemID: ingredient.chemID,
            };
        }));

        const parsedFormData = {
            ...formDataWithDate,
            area: parseFloat(formDataWithDate.area),
            rate: parseFloat(formDataWithDate.rate),
            tankNum: parseFloat(formDataWithDate.tankNum),
            tankVol: parseFloat(formDataWithDate.tankVol),
            ingredients: ingredientsData
        };

        // 🔧 Sanitize to remove undefined fields recursively
        const removeUndefinedFields = (obj) => {
            if (Array.isArray(obj)) {
                return obj.map(removeUndefinedFields);
            } else if (typeof obj === 'object' && obj !== null) {
                const cleaned = {};
                for (const [key, value] of Object.entries(obj)) {
                    if (value !== undefined) {
                        cleaned[key] = removeUndefinedFields(value);
                    }
                }
                return cleaned;
            }
            return obj;
        };

        const cleanedFormData = removeUndefinedFields(parsedFormData);

        try {
            if (editingSprayId) {
                await collectionRef.doc(editingSprayId).update(cleanedFormData);
                console.log('Spray updated successfully!');
            } else {
                await collectionRef.add(cleanedFormData);
                console.log('Spray added successfully!');
            }

            const snapshot = await collectionRef.get();
            const updatedSpraysData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setSprays(updatedSpraysData);

            clearForm(); // Clear the form after submission
        } catch (error) {
            console.log(formData);
            console.error('Error adding/updating Spray: ', error);
        }
    };


    const [searchQuery, setSearchQuery] = useState('');

    const handleSearch = (query) => {
        setSearchQuery(query);

        const filtered = chems.filter(chem =>
            ['name', 'manufacturer', 'type', 'description'].some(field =>
                chem[field]?.toLowerCase().includes(query.toLowerCase())
            )
        );

        setFilteredChems(filtered);
    };


    const stats = [
        { name: 'Tank Chem Vol', value: '405', unit: 'mins' },
        { name: 'Total Chem Vol', value: '3.65', unit: 'mins' },
        { name: 'Tank Price', value: '$3' },
        { name: 'Total Price', value: '$98.5%' },
    ]

    return (

        <div className={`${darkMode ? "text-white" : "text-black"} w-full h-full p-3`}>

            <DragDropContext onDragEnd={handleDragEnd}>

                {/*SiderBar*/}
                <Dialog open={sidebarOpen} onClose={setSidebarOpen} className="relative z-50 lg:hidden">
                    <DialogBackdrop
                        transition
                        className="fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear data-[closed]:opacity-0"
                    />

                    <div className="fixed inset-0 flex">
                        <DialogPanel
                            transition
                            className="relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-[closed]:-translate-x-full"
                        >
                            <TransitionChild>
                                <div
                                    className="absolute left-full top-0 flex w-16 justify-center pt-5 duration-300 ease-in-out data-[closed]:opacity-0">
                                    <button type="button" onClick={() => setSidebarOpen(false)} className="-m-2.5 p-2.5">
                                        <span className="sr-only">Close sidebar</span>
                                        <XMarkIcon aria-hidden="true" className="size-6 text-white"/>
                                    </button>
                                </div>
                            </TransitionChild>
                            {/* Sidebar component, swap this element with another sidebar if you like */}
                            <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-4">
                                <div className="flex h-16 shrink-0 items-center">
                                    <img
                                        alt="Your Company"
                                        src="https://tailwindcss.com/plus-assets/img/logos/mark.svg?color=indigo&shade=600"
                                        className="h-8 w-auto"
                                    />
                                </div>
                                <nav className="flex flex-1 flex-col">
                                    <ul className="flex flex-1 flex-col gap-y-7">
                                        <li>
                                            <ul className="-mx-2 space-y-1">
                                                {navigation.map((item) => (
                                                    <li key={item.name}>
                                                        <a
                                                            href={item.href}
                                                            className={classNames(
                                                                item.current
                                                                    ? 'bg-gray-50 text-indigo-600'
                                                                    : 'text-gray-700 hover:bg-gray-50 hover:text-indigo-600',
                                                                'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                                                            )}
                                                        >
                                                            <item.icon
                                                                aria-hidden="true"
                                                                className={classNames(
                                                                    item.current ? 'text-indigo-600' : 'text-gray-400 group-hover:text-indigo-600',
                                                                    'size-6 shrink-0',
                                                                )}
                                                            />
                                                            {item.name}
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </li>
                                        <li>
                                            <div className="text-xs/6 font-semibold text-gray-400">Your teams</div>
                                            <ul className="-mx-2 mt-2 space-y-1">
                                                {teams.map((team) => (
                                                    <li key={team.name}>
                                                        <a
                                                            href={team.href}
                                                            className={classNames(
                                                                team.current
                                                                    ? 'bg-gray-50 text-indigo-600'
                                                                    : 'text-gray-700 hover:bg-gray-50 hover:text-indigo-600',
                                                                'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                                                            )}
                                                        >
                              <span
                                  className={classNames(
                                      team.current
                                          ? 'border-indigo-600 text-indigo-600'
                                          : 'border-gray-200 text-gray-400 group-hover:border-indigo-600 group-hover:text-indigo-600',
                                      'flex size-6 shrink-0 items-center justify-center rounded-lg border bg-white text-[0.625rem] font-medium',
                                  )}
                              >
                                {team.initial}
                              </span>
                                                            <span className="truncate">{team.name}</span>
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </li>
                                        <li className="mt-auto">
                                            <Button
                                                // href="#"
                                                className="group -mx-2 flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold text-gray-700 hover:bg-gray-50 hover:text-indigo-600"
                                            >
                                                <Cog6ToothIcon
                                                    aria-hidden="true"
                                                    className="size-6 shrink-0 text-gray-400 group-hover:text-indigo-600"
                                                />
                                                Settings
                                            </Button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </DialogPanel>
                    </div>
                </Dialog>

                <div className={`z-20 relative grid grid-cols-5 gap-3 h-[calc(100dvh-5.5rem)] scrollbar-none`}>

                    {/* Static sidebar for desktop */}
                    <div className="col-span-1 animate-fadeIn lg:z-50 lg:flex lg:flex-col">
                        {/* Sidebar component, swap this element with another sidebar if you like */}
                        <div className={`flex grow flex-col gap-y-2 overflow-y-auto h-[calc(100dvh-5.5rem)] scrollbar-none rounded-lg border ${darkMode ? 'bg-bgDark border-neutral-700' : 'border-gray-200 bg-white'} pb-4`}>

                            {/*Inventory Header*/}
                            <div className={`${darkMode ? ' border-neutral-700' : ''} border-b-2 border-dashed px-4 py-2`}>
                                <div className="flex items-center">
                                    <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-green-600/15 sm:mx-0 sm:size-10">
                                        <TOTE aria-hidden="true" className="size-6 text-green-600" />
                                    </div>

                                    <h2 className="ml-3 text-base font-semibold tracking-widest">
                                        Inventory [{chems.length}]
                                    </h2>

                                </div>
                            </div>

                            {/*SideBar*/}
                            <div className="flex flex-1 flex-col scrollbar-none overflow-x-hidden">
                                <div className="flex flex-1 flex-col gap-y-7 scrollbar-none overflow-x-hidden">
                                    <div>

                                        {/*Inventory Search*/}
                                        <div className={`p-2`}>
                                            <div className={`sm:col-span-1 relative w-full`}>
                                                <label
                                                    className={`absolute ${darkMode ? 'bg-bgDark' : 'bg-white'} -top-2 left-2 inline-block rounded-lg px-1 text-xs font-medium`}
                                                >
                                                    Search
                                                </label>
                                                <Input
                                                    type="string"
                                                    placeholder={`Search Inventory`}
                                                    value={searchQuery}
                                                    onChange={(e) => handleSearch(e.target.value)}
                                                    className={`block w-full ${darkMode ? 'bg-bgDark outline-neutral-700' : 'bg-white outline-gray-300'} placeholder:text-xs placeholder:italic rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                                />
                                            </div>
                                        </div>

                                        {/*Inventory*/}
                                        <div className="px-2 space-y-1 scrollbar-none overflow-x-hidden">


                                            <Droppable droppableId={CHEMS_LIST_ID}>
                                                {(provided) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.droppableProps}
                                                        className={`space-y-1`}
                                                    >

                                                        {filteredChems.length === 0 ? (
                                                            // Display custom dialog if sprays array is empty
                                                            <div
                                                                className="absolute flex w-full h-full justify-center items-center">
                                                                <div
                                                                    className={`flex animate-fadeInFast flex-col items-center ${darkMode ? "text-white" : "text-black"} w-fit px-24 py-3 h-fit mr-auto ml-auto justify-center rounded-lg hover:scale-105`}>

                                                                    <TOTE className={`size-12 text-gray-400`}/>
                                                                    <h3 className="mt-2 text-sm font-semibold">No Items</h3>
                                                                    <p className="mt-1 text-sm text-gray-500">Get started by
                                                                        creating a new Item.</p>
                                                                    <div className="mt-6">
                                                                        <Button
                                                                            type="button"
                                                                            className="inline-flex items-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                                                            // onClick={toggleCollapse}
                                                                        >
                                                                            <PlusIcon aria-hidden="true" className="-ml-0.5 mr-1.5 size-5"/>
                                                                            Add Item
                                                                        </Button>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        ) : (

                                                            <>
                                                                {filteredChems.map((chem, index) => (
                                                                    <Draggable
                                                                        draggableId={`chem-${chem.id}`}
                                                                        index={index}
                                                                        key={`chem-${chem.id}`}
                                                                    >
                                                                        {(provided) => (
                                                                            <div
                                                                                ref={provided.innerRef}
                                                                                {...provided.draggableProps}
                                                                                {...provided.dragHandleProps}
                                                                                className={`hover:border-l-2 hover:border-green-600 hover:bg-green-600/25 hover:text-green-600 rounded-r-lg group flex items-center gap-x-2 py-2 text-sm/6 font-semibold`}
                                                                            >
                                                                                {/*<div className={`rounded-full w-8 h-8 flex items-center border ${darkMode ? 'border-neutral-700' : ''}`}>*/}
                                                                                {/*    <img*/}
                                                                                {/*        alt={''}*/}
                                                                                {/*        src={logo}*/}
                                                                                {/*        className={`w-8 object-cover`}*/}
                                                                                {/*    />*/}
                                                                                {/*</div>*/}

                                                                                <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-green-600/15 sm:mx-0 sm:size-10">
                                                                                    <LOGO aria-hidden="true" className="size-6 text-green-600" />
                                                                                </div>

                                                                                <div className={`flex flex-col`}>
                                                                                    <div className={`text-sm line-clamp-1 tracking-widest`}>{chem.name}</div>
                                                                                    <div className={`text-xs text-gray-500 line-clamp-1 tracking-widest`}>{chem.rate} oz/1000 sqft</div>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </Draggable>
                                                                ))}
                                                            </>
                                                        )}





                                                        {provided.placeholder}
                                                    </div>
                                                )}
                                            </Droppable>


                                        </div>
                                    </div>


                                    <li className="mt-auto">
                                        <Button
                                            // href="#"
                                            className="group -mx-2 flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold text-gray-700 hover:bg-gray-50 hover:text-indigo-600"
                                        >
                                            <Cog6ToothIcon
                                                aria-hidden="true"
                                                className="size-6 shrink-0 text-gray-400 group-hover:text-indigo-600"
                                            />
                                            Settings
                                        </Button>
                                    </li>


                                </div>
                            </div>

                        </div>
                    </div>

                    {/*Body*/}
                    <div className="col-span-4">

                        {/*Header*/}
                        <div className={`rounded-lg animate-fadeIn top-0 z-40 flex h-12 shrink-0 items-center gap-x-4 border ${darkMode ? 'border-neutral-700 bg-bgDark' : 'border-gray-200 bg-white'} px-3 shadow-sm sm:gap-x-6 sm:px-3 lg:px-3`}>
                            <Button type="button" onClick={() => setSidebarOpen(true)}
                                    className="-m-2.5 p-2.5 text-gray-700 lg:hidden">
                                <span className="sr-only">Open sidebar</span>
                                <Bars3Icon aria-hidden="true" className="size-6"/>
                            </Button>

                            {/* Separator */}
                            <div aria-hidden="true" className="h-6 w-px bg-gray-200 lg:hidden"/>

                            {/*Content*/}
                            <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">

                                <div className="w-full ml-auto flex items-center gap-x-4 lg:gap-x-6">

                                    <div className={`flex items-center`}>
                                        <img
                                            alt=""
                                            src={imageICON}
                                            className={`h-10 w-auto`}
                                        />

                                        <div className={`tracking-widest font-semibold`}>GROLINKZ's Spray Builder</div>

                                    </div>

                                    <button onClick={() => triggerNotification("productUpdateSuccess")} type="button" className="ml-auto -m-2.5 p-2.5 text-gray-400 hover:text-gray-500">
                                        <span className="sr-only">View notifications</span>
                                        <BellIcon aria-hidden="true" className="size-6"/>
                                    </button>

                                    {/* Separator */}
                                    <div aria-hidden="true" className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200"/>

                                    {/* Profile dropdown */}
                                    {/*<Link*/}
                                    {/*    to={'/Sprays'}*/}
                                    {/*    className="w-fit flex bg-red-600/50 text-sm px-2 rounded-lg items-center focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"*/}
                                    {/*>*/}
                                    {/*    <XMarkIcon aria-hidden="true" className="size-5 hover:text-opacity-50 text-red-500"/>*/}
                                    {/*    Close Builder*/}
                                    {/*</Link>*/}


                                    <Link
                                        to="/content?nav=Spray%20Calculator"
                                        className="inline-flex items-center gap-x-1.5 rounded-md bg-red-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                    >
                                        <XMarkIcon aria-hidden="true" className="-ml-0.5 size-5" />
                                        Close Builder
                                    </Link>


                                </div>
                            </div>
                        </div>

                        {/*Main*/}
                        <main className={`z-40 overflow-hidden scrollbar-none`}>

                            <div className={`z-40 animate-fadeIn border h-[calc(100dvh-9rem)] scrollbar-none mt-2 rounded-lg ${darkMode ? 'bg-bgDark border-neutral-700' : 'bg-white'} grid grid-cols-3`}>

                                {/*Ingredients List*/}
                                <div className={`col-span-1 border-r-2 ${darkMode ? 'border-neutral-700' : ''}`}>


                                    {/*Ingredients Header*/}
                                    <div className={`${darkMode ? ' border-neutral-700' : ''} border-b-2 border-dashed px-4 py-2 sm:px-6`}>
                                        <div className="flex items-center justify-between">
                                            <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-green-600/15 sm:mx-0 sm:size-10">
                                                <TOTE aria-hidden="true" className="size-6 text-green-600" />
                                            </div>

                                            <h2 className="text-base font-semibold tracking-widest">
                                                Ingredients
                                            </h2>

                                            <div className="ml-3 flex h-7 items-center">
                                                <Button
                                                    type="button"
                                                    onClick={clearForm}
                                                    className="relative rounded-md hover:text-red-500 hover:animate-heartbeat"
                                                >
                                                    <span className="absolute -inset-2.5" />
                                                    <span className="sr-only">Clear Form</span>
                                                    <XCircleIcon aria-hidden="true" className="size-6" />
                                                </Button>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Ingredients Section */}
                                    <div className={`relative px-1 py-1`}>
                                        <Droppable droppableId={INGREDIENTS_LIST_ID}>
                                            {(provided, snapshot) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.droppableProps}
                                                    className={`h-[calc(100dvh-13.25rem)] overflow-auto scrollbar-none ${snapshot.isDraggingOver ? "bg-green-600/25" : ""}`}
                                                >
                                                    {formData.ingredients.length === 0 ? (
                                                        // Display custom dialog if sprays array is empty
                                                        <div className="absolute flex w-full h-full justify-center items-center">
                                                            <div className={`flex animate-fadeInFast flex-col items-center ${darkMode ? "text-white" : "text-black"} py-3 h-fit mr-auto ml-auto justify-center rounded-lg hover:scale-105`}>

                                                                <TOTE className={`size-12 text-gray-400`}/>
                                                                <h3 className="mt-2 text-sm font-semibold">No Ingredients</h3>
                                                                <p className="mt-1 text-sm text-gray-500">Drag an item from your inventory to start!</p>
                                                                <div className="mt-6">
                                                                    <Link
                                                                        to="/content?nav=Product%20Inventory"
                                                                        // to={'/Chems'}
                                                                        className="inline-flex items-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                                                        // onClick={toggleCollapse}
                                                                    >
                                                                        <PlusIcon aria-hidden="true" className="-ml-0.5 mr-1.5 size-5"/>
                                                                        New Item
                                                                    </Link>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    ) : (

                                                        <div className={`space-y-2`}>
                                                            {formData.ingredients.map((ingr, index) => (
                                                                <Draggable
                                                                    draggableId={`ingredient-${ingr.id}`}
                                                                    index={index}
                                                                    key={`ingredient-${ingr.id}`}
                                                                >
                                                                    {(provided) => (
                                                                        <div
                                                                            ref={provided.innerRef}
                                                                            {...provided.draggableProps}
                                                                            {...provided.dragHandleProps}
                                                                            className={`border animate-zoomBounce ${darkMode ? 'border-neutral-700 bg-bgDark' : 'bg-white'} rounded-lg group p-2`}
                                                                        >
                                                                            <div className={`flex items-center gap-x-2 text-sm font-semibold`}>
                                                                                <div className="mx-auto flex size-8 shrink-0 items-center justify-center rounded-full bg-green-600/15 sm:mx-0 sm:size-10">
                                                                                    <JUG aria-hidden="true" className="size-6 text-green-600" />
                                                                                </div>

                                                                                <div className="flex flex-col w-full">
                                                                                    <div className="text-sm line-clamp-1 tracking-widest">{ingr.name}</div>
                                                                                    <div className="text-xs text-gray-500 line-clamp-1 tracking-widest">
                                                                                        {ingr.rate} oz/1000 sqft
                                                                                    </div>

                                                                                </div>
                                                                            </div>

                                                                            <div className={`mt-3 space-y-3`}>
                                                                                <div className={`sm:col-span-1 relative w-full`}>
                                                                                    <label
                                                                                        className={`absolute ${darkMode ? 'bg-bgDark' : 'bg-white'} -top-2 left-2 inline-block rounded-lg px-1 text-xs font-medium`}
                                                                                    >
                                                                                        Rate
                                                                                    </label>
                                                                                    <Input
                                                                                        type="number"
                                                                                        id={`rate-${index}`}
                                                                                        name={`rate-${index}`}
                                                                                        value={ingr.rate}
                                                                                        onChange={(e) => handleIngredientChange(index, 'rate', e)}
                                                                                        className={`block w-full ${darkMode ? 'bg-bgDark outline-neutral-700' : 'bg-white outline-gray-300'} rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                                                                    />
                                                                                </div>
                                                                                <div className={`grid grid-cols-3 w-full`}>

                                                                                    <div className={`sm:col-span-1`}>
                                                                                        <div className={`text-gray-400 text-xs font-semibold tracking-widest`}>Tank Volume</div>
                                                                                        <div className={`tracking-widest text-sm font-semibold`}>0 <span className={`text-gray-500 text-xs`}>gal</span></div>
                                                                                    </div>

                                                                                    <div className={`sm:col-span-1`}>
                                                                                        <div className={`text-gray-400 text-xs font-semibold tracking-widest`}>Total Volume</div>
                                                                                        <div className={`tracking-widest text-sm font-semibold`}>0 <span className={`text-gray-500 text-xs`}>gal</span></div>
                                                                                    </div>

                                                                                    <div className={`sm:col-span-1`}>
                                                                                        <div className={`text-gray-400 text-xs font-semibold tracking-widest`}>Total Price</div>
                                                                                        <div className={`tracking-widest text-sm font-semibold`}><span className={`text-green-600 text-xs`}>$</span>0
                                                                                        </div>
                                                                                    </div>

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </Draggable>
                                                            ))}
                                                        </div>
                                                    )}





                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Droppable>
                                    </div>


                                </div>

                                {/*Data Points*/}
                                <div className={`col-span-2 relative`}>

                                    {/* Inventory Header */}
                                    <div className={`${darkMode ? 'border-neutral-700' : ''} relative border-b-2 border-dashed px-4 py-4`}>
                                        {/* Icon (left aligned, visually floated) */}
                                        <div className="absolute left-4 top-1/2 -translate-y-1/2 flex size-12 items-center justify-center rounded-full bg-green-600/15 sm:size-10">
                                            <SPRAYER aria-hidden="true" className="size-6 text-green-600" />
                                        </div>

                                        {/* Centered Title */}
                                        <h2 className="text-center text-base font-semibold tracking-widest">
                                            Spray Info
                                        </h2>
                                    </div>

                                    {/*Totals Header*/}
                                    <div className={`${darkMode ? 'border-neutral-700' : ''} relative border-b-2 border-dashed px-4 py-4`}>
                                        <div className="mx-auto max-w-7xl">
                                            <div className="grid grid-cols-1 gap-px sm:grid-cols-2 lg:grid-cols-4">
                                                {stats.map((stat) => (
                                                    <div key={stat.name} className="px-4 sm:px-6 lg:px-8">
                                                        <p className="text-xs/3 font-medium text-gray-400">{stat.name}</p>
                                                        <p className="mt-2 flex items-baseline gap-x-2">
                                                            <span className="text-xl font-semibold tracking-tight">{stat.value}</span>
                                                            {stat.unit ? <span className="text-sm text-gray-400">{stat.unit}</span> : null}
                                                        </p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="w-full relative flex-1 px-4 sm:px-6">


                                        <form
                                            onSubmit={handleSubmit}
                                            className="mt-2 w-full rounded-lg overflow-y-auto max-h-[calc(100vh-18.5rem)] scrollbar-none animate-fadeIn grid grid-cols-1 gap-x-6 gap-y-1 sm:grid-cols-6">

                                            <div className="sm:col-span-full text-white justify-center items-center text-center text-xs">IDENTIFIERS</div>

                                            {/*Name*/}
                                            <div className="sm:col-span-3 relative flex mt-2 mb-2">
                                                <label
                                                    className={`absolute ${darkMode ? 'bg-bgDark' : 'bg-white'} -top-2 left-2 inline-block rounded-lg px-1 text-xs font-medium`}
                                                >
                                                    Spray Name
                                                </label>
                                                <Input
                                                    type="text"
                                                    id="name"
                                                    name="name"
                                                    placeholder="Enter Spray Name..."
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    className={`block w-full ${darkMode ? 'bg-bgDark outline-neutral-700' : 'bg-white outline-gray-300'} rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                                />
                                            </div>

                                            {/*Date*/}
                                            <div className="sm:col-span-3 relative flex mt-2 mb-2">
                                                <label
                                                    className={`absolute ${darkMode ? 'bg-bgDark' : 'bg-white'} -top-2 left-2 inline-block rounded-lg px-1 text-xs font-medium`}
                                                >
                                                    Date
                                                </label>
                                                <Input
                                                    type="date"
                                                    id="date"
                                                    name="date"
                                                    placeholder="Enter Chem Name..."
                                                    value={formData.date || currentDate}
                                                    onChange={handleChange}
                                                    className={`block w-full ${darkMode ? 'bg-bgDark outline-neutral-700' : 'bg-white outline-gray-300'} rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                                />
                                            </div>

                                            <div className={`sm:col-span-full ${darkMode ? "text-darkgreen" : "text-gray-400"} mt-2 mb-4 font-bold justify-center items-center text-center text-xxs`}>
                                                This is the data that the system uses to identify this spray in your
                                                database
                                            </div>

                                            <div className="sm:col-span-full text-white mt-4 justify-center items-center text-center text-xs">CLASSIFIERS</div>

                                            {/*Purpose*/}
                                            <div className="sm:col-span-3 relative flex items-center justify-start mt-2 mb-2">
                                                <label
                                                    className={`absolute ${darkMode ? 'bg-bgDark' : 'bg-white'} -top-2 left-2 inline-block rounded-lg px-1 text-xs font-medium`}
                                                >
                                                    Purpose
                                                </label>
                                                <Select
                                                    type="text"
                                                    id="purpose"
                                                    name="purpose"
                                                    value={formData.purpose}
                                                    onChange={handleChange}
                                                    className={`block w-full ${darkMode ? 'bg-bgDark outline-neutral-700' : 'bg-white outline-gray-300'} rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                                >
                                                    <option value="">Select...</option>
                                                    <option value="Aeration Recovery">Aeration Recovery</option>
                                                    <option value="Wetting Agent">Wetting Agent</option>
                                                    <option value="Pesticide Appplication">Pesticide Appplication
                                                    </option>
                                                    <option value="Fertilizer Application">Fertilizer Application
                                                    </option>
                                                    <option value="Herbicide Application">Herbicide Application</option>
                                                    <option value="Disease Control">Disease Control</option>
                                                    <option value="Insect Control">Insect Control</option>
                                                    <option value="Weed Control">Weed Control</option>
                                                    <option value="Fungicide Application">Fungicide Application</option>
                                                    <option value="Soil Amendments">Soil Amendments</option>
                                                    <option value="Plant Growth Regulators">Plant Growth Regulators
                                                    </option>
                                                    <option value="Drought Resistance">Drought Resistance</option>
                                                    <option value="Color Enhancement">Color Enhancement</option>
                                                    <option value="Sun Protection">Sun Protection</option>
                                                    <option value="Stress Management">Stress Management</option>
                                                    <option value="Algae Control">Algae Control</option>
                                                    <option value="pH Balancing">pH Balancing</option>
                                                    <option value="Seasonal Adjustments">Seasonal Adjustments</option>
                                                    <option value="Erosion Control">Erosion Control</option>
                                                    <option value="Water Quality Enhancement">Water Quality
                                                        Enhancement
                                                    </option>
                                                    <option value="Environmental Sustainability">Environmental
                                                        Sustainability
                                                    </option>
                                                </Select>
                                            </div>

                                            {/*Target Area*/}
                                            <div className="sm:col-span-3 relative flex items-center justify-start mt-2 mb-2">
                                                <label
                                                    className={`absolute ${darkMode ? 'bg-bgDark' : 'bg-white'} -top-2 left-2 inline-block rounded-lg px-1 text-xs font-medium`}
                                                >
                                                    Target Area
                                                </label>
                                                <Select
                                                    type="text"
                                                    id="target"
                                                    name="target"
                                                    value={formData.target}
                                                    onChange={handleChange}
                                                    className={`block w-full ${darkMode ? 'bg-bgDark outline-neutral-700' : 'bg-white outline-gray-300'} rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                                >
                                                    <option value="">Select...</option>
                                                    <option value="Greens">Greens</option>
                                                    <option value="Surrounds">Surrounds</option>
                                                    <option value="Collars">Collars</option>
                                                    <option value="Fairways">Fairways</option>
                                                    <option value="Tees">Tees</option>
                                                    <option value="Rough">Rough</option>
                                                </Select>
                                            </div>

                                            <div className={`sm:col-span-full ${darkMode ? "text-darkgreen" : "text-gray-400"} mt-2 mb-4 font-bold justify-center items-center text-center text-xxs`}>This
                                                is the data that the system uses to identify this Spray in your database
                                            </div>

                                            <div className="sm:col-span-full text-white mt-4 justify-center items-center text-center text-xs">MEASUREMENTS</div>

                                            {/*Area*/}
                                            <div className="sm:col-span-3 relative flex mt-2 mb-2">
                                                <label
                                                    className={`absolute ${darkMode ? 'bg-bgDark' : 'bg-white'} -top-2 left-2 inline-block rounded-lg px-1 text-xs font-medium`}
                                                >
                                                    Area
                                                </label>
                                                <Input
                                                    type="number"
                                                    id="area"
                                                    name="area"
                                                    value={formData.area}
                                                    onChange={handleChange}
                                                    className={`block w-full ${darkMode ? 'bg-bgDark outline-neutral-700' : 'bg-white outline-gray-300'} rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                                />
                                            </div>

                                            {/*Unit*/}
                                            <div className="sm:col-span-3 relative flex mt-2 mb-2">
                                                <label
                                                    className={`absolute ${darkMode ? 'bg-bgDark' : 'bg-white'} -top-2 left-2 inline-block rounded-lg px-1 text-xs font-medium`}
                                                >
                                                    Area Unit
                                                </label>
                                                <Select
                                                    type="text"
                                                    id="target"
                                                    name="target"
                                                    // value={formData.target}
                                                    // onChange={handleChange}
                                                    className={`block w-full ${darkMode ? 'bg-bgDark outline-neutral-700' : 'bg-white outline-gray-300'} rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                                >
                                                    <option value="">Select...</option>
                                                    <option value="sq. ft">sq. ft</option>
                                                    <option value="acres">acres</option>
                                                </Select>
                                            </div>

                                            {/*Rate*/}
                                            <div className="sm:col-span-full relative flex items-center mt-2 mb-2">
                                                <label
                                                    className={`absolute ${darkMode ? 'bg-bgDark' : 'bg-white'} -top-2 left-2 inline-block rounded-lg px-1 text-xs font-medium`}
                                                >
                                                    Rate
                                                </label>
                                                <Input
                                                    type="number"
                                                    id="rate"
                                                    name="rate"
                                                    value={formData.rate}
                                                    onChange={handleChange}
                                                    className={`block w-full ${darkMode ? 'bg-bgDark outline-neutral-700' : 'bg-white outline-gray-300'} rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                                />
                                                <label className="block text-litegreen text-xs ml-2 text-center w-1/3"
                                                       htmlFor="rate">
                                                    Gal per Acre:
                                                </label>
                                            </div>

                                            <div className={`sm:col-span-full ${darkMode ? "text-darkgreen" : "text-gray-400"} mt-2 mb-4 font-bold justify-center items-center text-center text-xxs`}>
                                                This is the data that the system uses to calculate your volume
                                            </div>

                                            <div className="sm:col-span-full text-white mt-4 justify-center items-center text-center text-xs">TANKS</div>

                                            {/*Tank Num*/}
                                            <div className="sm:col-span-3 relative flex mt-2 mb-2">
                                                <label
                                                    className={`absolute ${darkMode ? 'bg-bgDark' : 'bg-white'} -top-2 left-2 inline-block rounded-lg px-1 text-xs font-medium`}
                                                >
                                                    Area
                                                </label>
                                                <Input
                                                    type="number"
                                                    id="tankNum"
                                                    name="tankNum"
                                                    value={formData.tankNum}
                                                    onChange={handleChange}
                                                    step="0.01"
                                                    className={`block w-full ${darkMode ? 'bg-bgDark outline-neutral-700' : 'bg-white outline-gray-300'} rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                                />
                                            </div>

                                            {/*Volume*/}
                                            <div className="sm:col-span-3 relative flex mt-2 mb-2">
                                                <label
                                                    className={`absolute ${darkMode ? 'bg-bgDark' : 'bg-white'} -top-2 left-2 inline-block rounded-lg px-1 text-xs font-medium`}
                                                >
                                                    Tank Volume
                                                </label>
                                                <Input
                                                    type="number"
                                                    id="tankVol"
                                                    name="tankVol"
                                                    value={formData.tankVol}
                                                    onChange={handleChange}
                                                    step="0.01"
                                                    className={`block w-full ${darkMode ? 'bg-bgDark outline-neutral-700' : 'bg-white outline-gray-300'} rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                                                />
                                            </div>

                                            <div className={`sm:col-span-full ${darkMode ? "text-darkgreen" : "text-gray-400"} mt-2 mb-4 font-bold justify-center items-center text-center text-xxs`}>
                                                This is the data that the system uses to Calculate your per tank
                                                analysis
                                            </div>

                                            {/* Add more input fields as needed */}
                                            <div className="sm:col-span-full mb-3 flex w-full justify-center mt-4">
                                                {/* Add or Update Chem button */}
                                                <Button type="submit"
                                                        className="w-full bg-green-600 hover:bg-opacity-50 text-white tracking-widest py-1 px-4 rounded-md focus:outline-none focus:shadow-outline">
                                                    {/*{addOrUpdateButtonText}*/}
                                                    Add Spray
                                                </Button>
                                            </div>


                                        </form>


                                    </div>
                                </div>

                            </div>


                        </main>

                    </div>

                </div>

            </DragDropContext>

        </div>
    )
}

export default SprayBuilder
